var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOutcome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1357_114745)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#00223A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 8,
    width: 22,
    height: 30,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 19,
    width: 13,
    height: 7,
    fill: "#FF6C00"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 22,
    width: 4,
    height: 1,
    rx: 0.5,
    fill: "#CDF1F3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 22,
    width: 3,
    height: 1,
    rx: 0.5,
    fill: "#CDF1F3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 12,
    width: 12,
    height: 7,
    fill: "#CDF1F3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 14.5,
    width: 10,
    height: 2,
    rx: 1,
    fill: "#00223A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 26,
    width: 13,
    height: 6,
    fill: "#CDF1F3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 19,
    width: 9,
    height: 13,
    fill: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7995 27.868C22.6432 28.044 22.3438 28.044 22.1875 27.868C21.5234 27.1051 20 25.2861 20 24.2533C20 23.0093 21.1198 22 22.5 22C23.8802 22 25 23.0093 25 24.2533C25 25.2861 23.4766 27.1051 22.7995 27.868ZM22.5 23.5022C22.2005 23.5022 21.9271 23.6548 21.7708 23.8778C21.6276 24.1125 21.6276 24.4059 21.7708 24.6289C21.9271 24.8636 22.2005 25.0044 22.5 25.0044C22.7865 25.0044 23.0599 24.8636 23.2161 24.6289C23.3594 24.4059 23.3594 24.1125 23.2161 23.8778C23.0599 23.6548 22.7865 23.5022 22.5 23.5022Z",
    fill: "#00223A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 29,
    width: 3,
    height: 1,
    rx: 0.5,
    fill: "#00223A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 29,
    width: 4,
    height: 1,
    rx: 0.5,
    fill: "#00223A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 29.5,
    r: 0.5,
    fill: "#FF6C00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1357_114745"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutcome);
export default __webpack_public_path__ + "static/media/outcome.c1c0f50f0ca2d1cfdeb7ef0a6c784e75.svg";
export { ForwardRef as ReactComponent };